import React from 'react';
import { FieldArray } from 'react-final-form-arrays';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';

import WorkspaceAddMoreButton from '../../../DesktopOnboardingWizard/Workspaces/FormFields/WorkspaceAddMoreButton/WorkspaceAddMoreButton';
import FormWorkspaceField from './FormWorkspaceField/FormWorkspaceField';

function FormFields(): JSX.Element {
  return (
    <div className="onboarding-mobile-workspaces">
      <FieldGroup
        className="w-100 mt-4 pt-3"
        labelClassName="onboarding-mobile-workspaces-required-label"
        label="Who do you have 1:1s with?"
      >
        <p className="onboarding-mobile-workspaces-description mt-1 mb-0">
          We won’t invite them unless you provide their email.
        </p>
        <FieldArray name="workspaces">
          {({ fields }) =>
            fields.map((name, index) => (
              <FormWorkspaceField
                key={name}
                name={name}
                index={index}
                required
                fieldsCount={fields.length}
                remove={fields.remove}
              />
            ))
          }
        </FieldArray>
        <WorkspaceAddMoreButton label="Add more 1:1’s" />
      </FieldGroup>
    </div>
  );
}

export default FormFields;
